import { render, staticRenderFns } from "./ADashboardWidget.vue?vue&type=template&id=3fa75925"
import script from "./ADashboardWidget.ts?vue&type=script&lang=ts&external"
export * from "./ADashboardWidget.ts?vue&type=script&lang=ts&external"
import style0 from "./ADashboardWidget.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports